import { DialogSendButtonsKeys } from "../../../models/projectSettings"

export const dialogsTestIds = {
    addDialogTopicButton: "add-dialog-topic-button",
    addInMessageButton: "add-in-message-button",
    addNewUserChannel: "add-new-user-channel",
    addToMessageArticleButton: "add-to-message-article-button",
    AIAssistantCollapser: "ai-assistant-collapser",
    alertDialogCancel: "alert-dialog-cancel",
    alertDialogSubmit: "alert-dialog-submit",
    articleActions: "article-actions",
    attachmentCancel: "attachment-cancel",
    attachmentItem: "attachment-item",
    attachmentLink: "attachment-link",
    attachmentPreview: "attachment-preview",
    audioPlayer: "audio-player",
    audioPlayerDownloadButton: "audio-player-download-button",
    audioPlayerPlayButton: "audio-player-play-button",
    audioPlayerRepeatButton: "audio-player-repeat-button",
    audioPlayerSettingsToggle: "audio-player-settings-toggle",
    audioPlayerTimeline: "audio-player-timeline",
    audioPlayerVolumeToggle: "audio-player-volume-toggle",
    bulletListButton: "bullet-list-button",
    cancelButton: "cancel-button",
    cancelTransferDialogButton: "cancel-transfer-dialog-button",
    channel: "channel",
    clearSearchDialogsInput: "clear-search-dialogs-input",
    clientSurveyAccordion: "client-survey-accordion",
    clientSurveyAccordionToggle: "client-survey-accordion-toggle",
    closeViewAttachmentButton: "close-view-attachment-button",
    collapseSidebar: "collapse-sidebar",
    copyClientOrDialogIdButton: "copy-client-or-dialog-id-button",
    creatableTagSelectGroupHeading: "creatable-tag-select-group-heading",
    creatableTagSelectOption: "creatable-tag-select-option",
    creatableTagSelectTag: "creatable-tag-select-tag",
    createClientChannelUserId: "create-client-channel-user-id",
    customSectionAccordion: "custom-section-accordion",
    customSectionAccordionToggle: "custom-section-accordion-toggle",
    deleteDialogTopicButton: "delete-dialog-topic-button",
    deleteMessageAction: "delete-message-action",
    dialogAddChannelCard: "dialog-add-channel-card",
    dialogAddChannelCardSuffix: "channel-type",
    dialogAddChannelSearchClearButton: "dialog-add-channel-search-clear-button",
    dialogAddChannelSearchInput: "dialog-add-channel-search-input",
    dialogAttachments: "dialog-attachments",
    dialogAttachmentsMoreFiles: "dialog-attachments-more-files",
    dialogAutoHolding: "dialog-auto-holding",
    dialogAutoHoldingCancelButton: "dialog-auto-holding-cancel-button",
    dialogAutoTranslateToggle: "dialog-auto-translate-toggle",
    dialogBody: "dialog-body",
    dialogBodyLoadMore: "dialog-body-load-more",
    dialogChat: "dialog-chat",
    dialogChatAction: "dialog-chat-action",
    dialogChatLoader: "dialog-chat-loader",
    dialogContentProcessView: "dialog-content-process-view",
    dialogCreatingSubmitButton: "dialog-creating-submit-button",
    dialogFile: "dialog-file",
    dialogFileTitle: "dialog-file-title",
    dialogFileTitleAccept: "dialog-info-accept-file-title",
    dialogFileTitleDecline: "dialog-info-decline-file-title",
    dialogFileTitleInput: "dialog-info-file-title-input",
    dialogFileTitleLabel: "dialog-info-dialog-file-title",
    dialogFinishButton: "dialog-finish-button",
    dialogFinishCancelButton: "dialog-finish-cancel-button",
    dialogFooter: "dialog-footer",
    dialogHeader: "dialog-header",
    dialogHeaderFinishButton: "dialog-header-finish-button",
    dialogHeaderTransferButton: "dialog-header-transfer-button",
    dialogHistorySidebar: "dialog-history-sidebar",
    dialogHistoryChatPane: "dialog-history-chat-pane",
    dialogHistoryListItem: "dialog-history-list-item",
    dialogHistoryListItemChannelName: "dialog-history-list-item-channel-name",
    dialogHistoryListItemDate: "dialog-history-list-item-date",
    dialogHistoryListItemDirection: "dialog-history-list-item-direction",
    dialogHistoryListItemDirectionIcon: "dialog-history-list-item-direction-icon",
    dialogHistoryListItemOperatorName: "dialog-history-list-item-operator-name",
    dialogHistoryListItemTime: "dialog-history-list-item-time",
    dialogHistoryListPane: "dialog-history-list-pane",
    dialogHistoryListEmptyView: "dialog-history-list-empty-view",
    dialogHistoryListErrorView: "dialog-history-list-error-view",
    dialogHistoryMessagesContainer: "dialog-history-messages-container",
    dialogHistoryMessagesEmptyView: "dialog-history-messages-empty-view",
    dialogHistoryMessagesErrorView: "dialog-history-messages-error-view",
    dialogInfo: "dialog-info",
    dialogInfoContent: "dialog-info-content",
    dialogInfoSection: "dialog-info-section",
    dialogInfoCustomSectionsWrapper: "dialog-info-custom-sections-wrapper",
    dialogInfoCustomSectionsProcessView: "dialog-info-custom-sections-process-view",
    dialogInfoCustomSectionsErrorView: "dialog-info-custom-sections-error-view",
    dialogInfoSidebarContent: "dialog-info-sidebar-content",
    dialogInfoProcessView: "dialog-info-process-view",
    dialogInfoErrorView: "dialog-info-error-view",
    dialogInfoClientName: "dialog-info-client-name",
    dialogInfoSurveyFieldActions: "dialog-info-survey-field-actions",
    dialogInfoSurveyFieldActionButton: "dialog-info-survey-field-action-button",
    dialogInfoSurveyFieldCopyButton: "dialog-info-survey-field-copy-button",
    dialogInfoSurveyFieldInput: "dialog-info-survey-field-input",
    dialogInfoFilesExportSection: "dialog-info-files-export-section",
    dialogInfoAttachmentsTypeAll: "dialog-info-attachments-type-all",
    dialogInfoAttachmentsTypeClient: "dialog-info-attachments-type-client",
    dialogInfoLinkClientPopoverToggle: "dialog-info-link-client-popover-toggle",
    dialogInfoLinkClientPopoverCancel: "dialog-info-link-client-popover-cancel",
    dialogInfoLinkClientPopoverSave: "dialog-info-link-client-popover-save",
    dialogInfoCustomSectionOpenButton: "dialog-info-custom-section-open-button",
    dialogInfoLoader: "dialog-info-loader",
    dialogLeftActions: "dialog-left-actions",
    dialogList: "dialog-list",
    dialogListDefaultView: "dialog-list-default-view",
    dialogListErrorView: "dialog-list-error-view",
    dialogListFeedbackItem: "dialog-list-feedback-item",
    dialogListItem: "dialog-list-item",
    dialogListItemClientName: "dialog-list-item-client-name",
    dialogListItemLastMessage: "dialog-list-item-last-message",
    dialogListItemOnHold: "dialog-list-item-on-hold",
    dialogListItemLoader: "dialog-list-item-loader",
    dialogListLoader: "dialog-list-loader",
    dialogListProcessView: "dialog-list-process-view",
    dialogListToggle: "dialog-list-toggle",
    dialogMessageViewButton: "dialog-message-view-button",
    dialogMessageViewCloseButton: "dialog-message-view-close-button",
    dialogPathChannelTooltip: "dialog-path-channel-tooltip",
    dialogPathSelectedChannel: "dialog-path-selected-channel",
    dialogRightActionsDropdown: "dialog-right-actions-dropdown",
    dialogRightActionsMain: "dialog-right-actions-main",
    dialogSearchFilterBtn: "dialog-search-filter-btn",
    dialogStartButton: "dialog-start-button",
    dialogStartErrorBackButton: "dialog-start-error-back-button",
    dialogStartProgressCancelButton: "dialog-start-progress-cancel-button",
    dialogTimer: "dialog-badge-timer",
    dialogTopicsFiltered: "dialog-topics-filtered",
    dialogTopicsList: "dialog-topics-list",
    dialogTopicsModalContent: "dialog-topics-modal-content",
    dialogTopicsSearchClearButton: "dialog-topics-search-clear-button",
    dialogTopicsSearchInput: "dialog-topics-search-input",
    dialogTopicsTree: "dialog-topics",
    dialogTopicExpandButton: "dialog-topic-expand-button",
    dialogTopicItem: "dialog-topic-item",
    dialogTransferModal: "dialog-transfer-modal",
    dialogTransferForm: "dialog-transfer-form",
    dialogTransferModalSubmit: "dialog-transfer-modal-submit",
    dialogTransferOperatorQueuesFilter: "dialog-transfer-operator-queues-filter",
    dialogTransferOperatorRolesFilter: "dialog-transfer-operator-roles-filter",
    dialogTransferOperatorListItem: "dialog-transfer-operator-list-item",
    dialogTransferOperatorSearch: "dialog-transfer-operator-search",
    dialogTransferOperatorSearchClearButton: "dialog-transfer-operator-search-clear-button",
    dialogTransferOperatorsContainer: "dialog-transfer-operators-container",
    dialogTransferOperatorSearchInput: "dialog-transfer-operator-search-input",
    dialogTransferQueueTree: "dialog-transfer-queue-tree",
    dialogTransferQueueSearchClearButton: "dialog-transfer-queue-search-clear-button",
    dialogTransferQueueSearchInput: "dialog-transfer-queue-search-input",
    dialogTransferTabs: "dialog-transfer-tabs",
    dialogTranslateContextLoader: "dialog-translate-context-loader",
    dialogTranslateLanguageDropdown: "dialog-translate-language-dropdown",
    dialogView: "dialog-view",
    dialogViewDefault: "dialog-view-default",
    dialogViewLoader: "dialog-view-loader",
    dialogsFiltersClearButton: "dialogs-filters-clear-btn",
    dialogsLeftSidebarResizer: "dialogs-left-sidebar-resizer",
    dialogsRightSidebarResizer: "dialogs-right-sidebar-resizer",
    dialogsSearchFiltersCloseButton: "dialogs-search-filters-close-button",
    dialogsSearchFiltersQueryInput: "dialogs-search-filters-query-input",
    dialogsSearchFiltersSearchButton: "dialogs-search-filters-search-button",
    downloadAttachmentButton: "download-attachment-button",
    downloadButton: "download-button",
    draggingArea: "dragging-area",
    dropPlace: "drop-place",
    dropPlaceContent: "drop-place-content",
    editedMessage: "edited-message",
    editMessageAction: "edit-message-action",
    emailAnswerModeActionToggleButton: "email-answer-mode-action-toggle-button",
    emailBCCButton: "email-bcc-button",
    emailBCCInput: "email-bcc-input",
    emailCCButton: "email-cc-button",
    emailCCInput: "email-cc-input",
    emailQuoteExpandButton: "email-quote-expand-button",
    emailSubjectButton: "email-subject-button",
    emailSubjectInput: "email-subject-input",
    emailToInput: "email-to-input",
    emojiButton: "emoji-button",
    expandCollapseButton: "expand-collapse-button",
    expandEmailMessageAction: "expand-email-message-action",
    fastRepliesHotKeyCreateAction: "fast-reply-hotkey-create-action",
    fastRepliesHotKeyDeleteAction: "fast-reply-hotkey-delete-action",
    fastRepliesHotKeyEditAction: "fast-reply-hotkey-edit-action",
    fastRepliesHotKeyFormCancelButton: "fast-reply-hotkey-form-cancel-button",
    fastRepliesHotKeyFormFirstKeyInput: "fast-reply-hotkey-form-first-key-input",
    fastRepliesHotKeyFormSaveButton: "fast-reply-hotkey-form-save-button",
    fastRepliesHotKeyFormSecondKeyInput: "fast-reply-hotkey-form-second-key-input",
    fastRepliesItem: "fast-reply-item",
    fastRepliesSidebarSearchButton: "fast-replies-sidebar-search-button",
    fastRepliesSidebarSearchClearButton: "fast-replies-sidebar-search-clear-button",
    fastRepliesSidebarSearchInput: "fast-replies-sidebar-search-input",
    feedbackFormCloseButton: "feedback-form-close-button",
    feedbackFormFeedback: "feedback-form-feedback",
    feedbackFormHeartIcon: "feedback-form-heart-icon",
    feedbackFormRating: "feedback-form-rating",
    feedbackFormRetryButton: "feedback-form-retry-button",
    feedbackFormRobotDefault: "feedback-form-robot-default",
    feedbackFormRobotSuccess: "feedback-form-robot-success",
    feedbackFormSubmitButton: "feedback-form-submit-button",
    fileSelectionButton: "file-selection-button",
    filesExportAccordion: "files-export-accordion",
    filesExportAccordionToggle: "files-export-accordion-toggle",
    filesWithSectionsDownloadButton: "files-with-sections-download-button",
    filesWithSectionsFile: "files-with-sections-file",
    filesWithSectionsList: "files-with-sections-list",
    filesWithSectionsShowMore: "files-with-sections-show-more",
    filesWithSectionsShowMoreButton: "files-with-sections-show-more-button",
    filtersClientArbitrary: "filters-client-arbitrary",
    filtersClientChannel: "filters-client-channel",
    filtersClientChannelUserId: "filters-client-channel-user-id",
    filtersClientExternalId: "filters-client-external-id",
    filtersClientOmniUserId: "filters-client-omni-user-id",
    filtersClientPhoneNumber: "filters-client-phone-number",
    filtersDialogAccount: "filters-dialog-account",
    filtersDialogArbitrary: "filters-dialog-arbitrary",
    filtersDialogDateIcon: "filters-dialog-date-icon",
    filtersDialogDateInput: "filters-dialog-date-input",
    filtersDialogEfficiency: "filters-dialog-efficiency",
    filtersDialogMessage: "filters-dialog-message",
    filtersDialogOperators: "filters-dialog-operators",
    filtersDialogProcessedBy: "filters-dialog-processed-by",
    filtersDialogQueues: "filters-dialog-queues",
    filtersDialogRating: "filters-dialog-rating",
    filtersDialogReasons: "filters-dialog-reasons",
    filtersDialogStartEnd: "filters-dialog-start-end",
    filtersDialogStatus: "filters-dialog-status",
    filtersDialogTopics: "filters-dialog-topics",
    filtersDialogTopicsSearchClearButton: "filters-dialog-topics-search-clear-button",
    filtersDialogTopicsSearchInput: "filters-dialog-topics-search-input",
    filtersDialogId: "filters-dialog-id",
    filtersSlotInput: "filters-slot-input",
    filtersSlotSelect: "filters-slot-select",
    forwardEmailAnswerMode: "forward-email-answer-mode",
    galleryBox: "gallery-box",
    galleryBoxContent: "gallery-box-content",
    galleryPreviewer: "gallery-previewer",
    galleryPreviewerBackdrop: "gallery-previewer-backdrop",
    galleryPreviewerContent: "gallery-previewer-content",
    imageFileSelectionButton: "image-file-selection-button",
    linkedOperatorClientsDefaultView: "linked-operator-clients-default-view",
    linkedOperatorClientsErrorView: "linked-operator-clients-error-view",
    linkedOperatorClientsItem: "linked-operator-clients-item",
    linkedOperatorClientsItems: "linked-operator-clients-items",
    linkedOperatorClientsList: "linked-operator-clients-list",
    linkedOperatorClientsListToggle: "linked-operator-clients-list-toggle",
    linkedOperatorClientsProcessView: "linked-operator-clients-process-view",
    linkedOperatorClientsShowLinkedCheckbox: "linked-operator-clients-show-linked-checkbox",
    messageActionsButton: "message-actions-button",
    messageAttachmentsIncoming: "message-attachments-incoming",
    messageAttachmentsOutgoing: "message-attachments-outgoing",
    messageBasic: "message-basic",
    messageBasicAction: "message-basic-action",
    messageBasicBotIcon: "message-basic-bot-icon",
    messageBasicChannelIcon: "message-basic-channel-icon",
    messageBasicChannelTitle: "message-basic-channel-title",
    messageBasicFooter: "message-basic-footer",
    messageBasicInternalMessage: "message-basic-internal-message",
    messageBasicSendStatus: "message-basic-send-status",
    messageBasicSenderIcon: "message-basic-sender-icon",
    messageBasicSenderName: "message-basic-sender-name",
    messageBasicText: "message-basic-text",
    messageBasicTextClient: "message-basic-text-client",
    messageBasicTextOperator: "message-basic-text-operator",
    messageBasicTimestamp: "message-basic-timestamp",
    messageBasicUserIcon: "message-basic-user-icon",
    dialogHistoryMessageClientText: "dialog-history-message-client-text",
    dialogHistoryMessageOperatorText: "dialog-history-message-operator-text",
    messageDeletedText: "message-deleted-text",
    messageEndDialog: "message-end-dialog",
    messageEndDialogText: "message-end-dialog-text",
    messageInput: "message-input",
    messageInputEditor: "message-input-editor",
    messageInputEditorEditable: "message-input-editor-editable",
    messageInputFileInput: "message-input-file-input",
    messageLinkButton: "dialog-message-input-link-button",
    messagePinPreview: "message-pin-preview",
    messageReroute: "message-reroute",
    messageStartDialog: "message-start-dialog",
    messageStartDialogChannel: "message-start-dialog-channel",
    messageStartDialogDate: "message-start-dialog-date",
    messageStartDialogText: "message-start-dialog-text",
    messageUserTyping: "message-user-typing",
    nextAttachmentButton: "next-attachment-button",
    openArticleButton: "open-article-button",
    openCreatingOutgoingDialogButton: "open-creating-outgoing-dialog-button",
    openDialogHistoryIcon: "open-dialog-history-icon",
    openFastRepliesSidebarButton: "open-fast-replies-sidebar-button",
    openKBArticleById: "open-kb-article-by-id",
    openKnowledgeBaseSidebarButton: "open-knowledge-base-sidebar-button",
    openPreviousDialogInfoIcon: "open-previous-dialog-info-icon",
    operatorClientsDefaultView: "operator-clients-default-view",
    operatorClientsErrorView: "operator-clients-error-view",
    operatorClientsList: "operator-clients-list",
    operatorClientsListItem: "operator-clients-list-item",
    operatorClientsListToggle: "operator-clients-list-toggle",
    operatorClientsProcessView: "operator-clients-process-view",
    operatorEmailChannel: "operator-email-channel",
    operatorsListFilter: "operators-list-filter",
    operatorsSelect: "operators-select",
    orderedListButton: "ordered-list-button",
    paginationSelect: "pagination-select",
    pinMessageAction: "pin-message-action",
    pinPreviewCloseButton: "pin-preview-close-button",
    previousAttachmentButton: "previous-attachment-button",
    queueIdOnOperatorRefused: "queue-id-on-operator-refused",
    quoteMessageAction: "quote-message-action",
    rating: "rating",
    ratingStar: "rating-star",
    replaceButton: "replace-button",
    replyEmailAnswerMode: "reply-email-answer-mode",
    requestAIAssistByReqType: "request-ai-assist-by-req-type",
    resetCalendar: "reset-calendar",
    routingMessageModal: "routing-message-modal",
    routingMessageModalCloseButton: "routing-message-modal-close-button",
    routingMessageModalDeleteButton: "routing-message-modal-delete-button",
    screenSharingAccordion: "screen-sharing-accordion",
    screenSharingAccordionToggle: "screen-sharing-accordion-toggle",
    searchDialogsButton: "search-dialogs-button",
    searchDialogsInput: "search-dialogs-input",
    selectedClientErrorView: "selected-client-error-view",
    selectedDialogErrorView: "selected-dialog-error-view",
    sendArticleButton: "send-article-button",
    sendMessageAction: "send-message-action",
    sendMessageActionDropdownButton: "send-message-action-dropdown-button",
    setInputMaximizedButton: "set-input-maximized-button",
    showCalendar: "show-calendar",
    showDeletedMessageToggle: "show-deleted-message-toggle",
    showEditHistoryToggle: "show-edit-history-toggle",
    showMoreButton: "show-more-button",
    stickerButton: "sticker-button",
    stickerPopoverItem: "sticker-popover-item",
    textToggle: "text-toggle",
    transferMessageTextarea: "transfer-message-textarea",
    translateMessageToggle: "translate-message-toggle",
    translatedMessages: "translated-messages",
    xBtnClose: "x-btn-close",
    [DialogSendButtonsKeys.Hold]: "message-input_submit-and-hold-button",
    [DialogSendButtonsKeys.InternalMessage]: "message-input_send-internal-message",
    [DialogSendButtonsKeys.Message]: "message-input_submit-button",
    [DialogSendButtonsKeys.TranslateAndHold]: "message-input_submit-and-translate-and-hold-button",
    [DialogSendButtonsKeys.TranslateAndSend]: "message-input_submit-and-translate-and-send-button"
} as const
